import Role from '~/models/Role';
import { lowerCaseFirstLetter } from './helpers/string';
import User from '~/models/User';

// TODO: These hardcoded privileges should be replaced by actual privileges from
// CIP once they are retrieved by the CSOAR backend. For now, we are passing all
// privileges used in the Kanso nav so that the nav items are not affected by
// the latest RBAC changes in CSOAR.

export const MOCK_USER_PRIVILEGES = [
    'CSEAccess',
    'CanDisplayAlertResponsePageListView',
    'UnifiedMonitorsViewAccess',
    'CanDisplayMonitoringSLOListView',
    'HealthEventsAccess',
    'AlertsConnectionsViewAccess',
    'ParsersViewAccess',
    'CollectorsAccess',
    'IngestAccess',
    'ArchiveAccess',
    'CollectionDataForwardingAccess',
    'FieldsViewAccess',
    'NewFERViewAccess',
    'PartitionsNewViewAccess',
    'ScheduledViewsAccess',
    'DataForwardingAccess',
    'MetricsRulesAccess',
    'MetricsExtractionAccess',
    'MetricsTransformationRulesAccess',
    'AccountOverviewAccess',
    'AccountDataManagementAccess',
    'AccountUpgradeAccess',
    'UsersTabAccess',
    'RolesTabAccess',
    'PasswordPolicyAccess',
    'WhitelistAccess',
    'AccessKeysAccess',
    'PoliciesAccess',
    'SAMLAccess',
    'InstallationTokensAccess',
    'CloudSoarAccess',
    'CloudSoarIncidentAccess',
    'CloudSoarIncidentTriageAccess',
    'CloudSoarEntitiesAccess',
    'CloudSoarReportAccess',
    'CloudSoarAppCentralAccess',
    'CloudSoarPlaybooksAccess',
    'CloudSoarIncidentTemplatesAccess',
    'CloudSoarIntegrationsAccess',
    'CloudSoarAutomationRulesAccess',
    'CloudSoarBridgeMonitoringAccess',
    'CloudSoarGeneralConfigure',
    'CloudSoarNotificationConfigure',
    'CloudSoarUserManagementGroups',
    'CloudSoarCustomizationIncidentLabels',
    'CloudSoarCustomizationFields',
    'CloudSoarCustomizationIncidentLabels',
    'CloudSoarNotificationTriage'
];

export const MOCKED_CSOAR_PRIVILEGES = [
    'CloudSoarIncidentAccess',
    'CloudSoarIncidentTriageAccess',
    'CloudSoarEntitiesAccess',
    'CloudSoarReportAccess',
    'CloudSoarAppCentralAccess',
    'CloudSoarPlaybooksAccess',
    'CloudSoarIncidentTemplatesAccess',
    'CloudSoarIntegrationsAccess',
    'CloudSoarAutomationRulesAccess',
    'CloudSoarBridgeMonitoringAccess',
    'CloudSoarGeneralConfigure',
    'CloudSoarNotificationConfigure',
    'CloudSoarUserManagementGroups',
    'CloudSoarCustomizationIncidentLabels',
    'CloudSoarCustomizationFields',
    'CloudSoarCustomizationIncidentLabels',
    'CloudSoarNotificationTriage'
];

export const MOCK_USER_PRIVILEGES_STRUCTURED = MOCK_USER_PRIVILEGES.reduce(
    (acc, privilege) =>
        Object.assign(acc, {
            [privilege]: {
                key: privilege,
                description: '',
                value: true
            }
        }),
    {}
);

export const generateMockedCsoarUserPrivileges = () => {
    return Role.cipPermissions().then(csoarPermission => {
        const { data } = csoarPermission;
        const allPrivileges = {};
        for (const privilege in MOCK_USER_PRIVILEGES_STRUCTURED) {
            const finalPrivileges = MOCK_USER_PRIVILEGES_STRUCTURED[privilege];
            if (MOCKED_CSOAR_PRIVILEGES.includes(privilege)) {
                const capitalizedPrivilege = lowerCaseFirstLetter(privilege);
                const csoarPermissionConversion = data[capitalizedPrivilege];
                finalPrivileges.value = User.can(csoarPermissionConversion);
            }
            allPrivileges[privilege] = finalPrivileges;
        }
        return allPrivileges;
    });
};
